// @ts-nocheck

import * as React from 'react';

import css from './survey.css';

import useFluxStore from 'src/flux/useFluxStore';
import SenseLogo from 'src/images/sense-logo.svg';


type Props = {
  children: React.ReactNode;
  params: {
    eventId?: string;
    sentEventId?: string;
  };
  store: () => Record<any, any>;
};

const SurveyNavigation = ({children, params}: Props) => {
  const store = useFluxStore();

  let logo, logoLink, brandColor;
  if (params.eventId) {
    const brandingSettings = store.survey.getBrandingSettings(params.eventId);
    logo = brandingSettings.logo || '';
    logoLink = brandingSettings && brandingSettings.logoLink;
    brandColor = brandingSettings && brandingSettings.color;
  } else if (params.sentEventId) {
    const sentEvent = store.sentEvents.byId(params.sentEventId);
    if (sentEvent) {
      logo = sentEvent.brandingSettings.logo;
      logoLink = sentEvent.brandingSettings.logoLink;
      brandColor = sentEvent.brandingSettings.color;
    }
  }

  return (
    <div className={css.container}>
      {brandColor && (
        <div
          className={css.topBranding}
          style={{backgroundColor: brandColor}}
        />
      )}
      <nav className={css.nav}>
        <Logo logo={logo} logoLink={logoLink} />
      </nav>
      {children}
    </div>
  );
};

const Logo = ({logo, logoLink}: {logo?: string; logoLink?: string}) => {
  if (logo) {
    return logoLink ? (
      <a href={logoLink} rel="noopener noreferrer" target="_blank">
        <img className={css.logo} src={logo} />
      </a>
    ) : (
      <img className={css.logo} src={logo} />
    );
  }
  return (
    <a href="/" className={css.logo}>
      <SenseLogo />
    </a>
  );
};

export default SurveyNavigation;
